import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/banner_work.jpeg'


const _hoisted_1 = {
  key: 0,
  style: {"padding":"8px"}
}
const _hoisted_2 = { style: {"margin-bottom":"20px"} }
const _hoisted_3 = {
  class: "compact-chips",
  style: {"display":"flex","flex-wrap":"wrap","gap":"4px","margin-bottom":"4px"}
}
const _hoisted_4 = {
  class: "compact-chips",
  style: {"display":"flex","flex-wrap":"wrap","gap":"4px","margin-bottom":"4px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"0.6em"}
}
const _hoisted_6 = {
  key: 1,
  style: {"font-size":"0.6em"}
}
const _hoisted_7 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_8 = { style: {"margin":"0 0 12px 0","color":"#666","font-size":"14px","font-weight":"bold"} }
const _hoisted_9 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#666"}
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }

import { computed, onMounted, reactive, ref, watch } from 'vue';

// icons
import { personCircle, compass, arrowForward, navigate, settingsOutline, checkmark, arrowBack,
        add, close, checkmarkCircle, alertCircle, pencil, peopleOutline, qrCodeOutline,
        createOutline, calendarOutline, calendarClearOutline, play, } from 'ionicons/icons';

// components
import { IonPage, IonToolbar, IonContent, IonModal, IonHeader, IonTitle,
        IonCard, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonSegment, IonSegmentButton,
        IonGrid, IonCol, IonRow, IonSpinner, IonNote, IonButtons, IonButton, IonIcon,
        IonBadge, IonChip, IonList, IonItem, IonLabel, IonAccordion, IonAccordionGroup,
        loadingController, modalController, toastController, } from '@ionic/vue';
import ActionAccordionGroup from '@/components/shared/ActionAccordionGroup.vue';
import ParentConsentSignatureModal from '@/components/modals/ParentConsentSignatureModal.vue';

// Secondary School
import SLPModal from '@/components/secondary/ABSLPModal.vue';

// types
import { Session, Discipline, Profession, Program, Step1Option, User, Service, Tag, TagItem, } from '@/types';

// composables
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import { utils } from '@/composables/utils';

// services
import ABSService from '@/services/ABSService';

// methods

export default /*@__PURE__*/_defineComponent({
  __name: 'SecStudentActionHeartEyeEmoji',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const { openImageModal, openModal, getF3YearDSE, getF4YearDSE, getF5YearDSE, getF6YearDSE, promptRollCallCode,
        getProxyImgLink, getQRCodeUrl, copyText, openServiceModal, } = utils();

// state variables
const loadingData = computed(() => store.state.loadingUser || store.state.loadingData);
const loadingPortalData = computed(() => store.state.loadingUser || store.state.loadingData || store.state.loadingPortalData);
const settings = computed(() => store.state.settings);
const user = computed(() => store.state.user);
const userRelatedSchool = computed(() => store.getters.userRelatedSchool);

// Work Services / Sessions
const workServices = computed<Service[]>(() => store.getters.getServicesByTypes(["Work"]));
const workVisitEvents = computed<Session[]>(() => store.getters.getSessionsByAnchorEventId('work-campus-visit'));
const workWorkshopEvents = computed<Session[]>(() => store.getters.getSessionsByAnchorEventId('work-workshop-2'));

const isShortlisted = (session: any) => {
  if (!session) return false;
  const { interviewStatus, response } = session.userResponse;
  return interviewStatus?.includes('Accepted') || ['Attended', 'Confirmed'].includes(response);
}

// Interactive UI state
const selectedTagId = ref<string>('');
const selectedApplicationStatus = ref<string>('');
const selectedLead = ref<boolean>(false);

// Tags
const tags = computed<Tag[]>(() => store.state.tags);
const tagItems = computed<TagItem[]>(() => store.state.tagItems);

// Interactive UI methods
const selectTag = (tagId: string) => {
  selectedTagId.value = selectedTagId.value === tagId ? '' : tagId;
  console.log('Selected tag:', selectedTagId.value);
};
const selectApplicationStatus = (status: string) => {
  selectedApplicationStatus.value = selectedApplicationStatus.value === status ? '' : status;
  console.log('Selected application status:', selectedApplicationStatus.value);
};

// Computed filtered results
const filteredResults = computed(() => {
  return tagItems.value.filter(result => {
    if (selectedTagId.value) {
      if (result.tagId != selectedTagId.value) return false;
    }
    if (selectedApplicationStatus.value) {
      const ev = store.getters.getSessionById(result.sessionId);
      switch (selectedApplicationStatus.value) {
        case 'Click':
          return result.isClick == true;
        case 'Applied':
          return ev.userResponse != null;
        case 'Nominated':
          return ev.userResponse && ev.userResponse.nominatedBy != null;
        case 'Confirmed interview':
          return ev.userResponse && ev.userResponse.interviewStatus;
        case 'Interview passed':
          return ev.userResponse && ev.userResponse.interviewStatus?.includes('Accepted');
      }
    }
    return true;
  });
});

// Open result modal
const openResultModal = async (result: any) => {
  console.log('Opening result:', result);
  // You can implement modal opening logic here
  const { sessionId, serviceId } = result;
  
  if (sessionId) {
    const ev = store.getters.getSessionById(sessionId);
    return await openServiceModal(ev.serviceId, ev, true);
  }

  if (serviceId) {
    return await openServiceModal(serviceId);
  }
};

// Click status methods
const getClickStatus = (result: any) => {
  return result.isClicked || false;
};

const toggleClickItem = (result: any) => {
  // Find the item in mockResults and toggle its isClicked status
  const item = tagItems.value.find(item => item.id === result.id);
  if (item && 'isClicked' in item) {
    item.isClicked = !item.isClicked;
    console.log(`${result.title} clicked:`, item.isClicked);
  }
};

const getServices = (targetNature: any = null) => {
  const yearDSE = Number(user.value.yearDSE);
  const targetForms = (yearDSE == getF6YearDSE() ? ['F.6', 'F.5'] : (yearDSE == getF4YearDSE() ? ['F.4'] : ['F.5']));
  const targetServices = (workServices.value || []).filter(s => {
    if (targetNature && s.nature != targetNature) return false; // Workshop / Visit
    if (store.getters.getLastAppliedSessionByServiceId(s.id)) return true; // contain applied session
    if (s.status == 'Inactive' || !s.nature) return false;
    
    // only include services related to the form
    if (targetForms && s.targetForms && s.targetForms.length > 0 && !s.targetForms.some(f => targetForms.includes(f))) return false;
    
    // skip because nominated by teachers (TBC: align layout with teachers?)
    if (['Talk at your school', 'Video'].includes(s.nature)) return false;

    return s.targetSchoolBands.length == 0 || userRelatedSchool.value.id == 'beacon1' ||
            s.targetSchoolBands.includes(userRelatedSchool.value.band);
  }).map(s => {
    s.lastAppliedSession = store.getters.getLastAppliedSessionByServiceId(s.id); // SLP visit / workshop
    return s;
  });
  return targetServices;
};
const getWorkshopServicesByUserLevel = (userLevel) => {
  const services = getServices('Workshop');
  switch (userLevel) {
    case 'eligible-work-applicant': 
      return services.filter(s => s.status != 'Inactive' && !isShortlisted(s.lastAppliedSession));
    case 'shortlisted-work-applicant':
      return services.filter(s => isShortlisted(s.lastAppliedSession));
  }
  return services;
}

/**
 * INIT
 */
const isUserAttendedLesson = (lessonId) => (user.value.sessionResponses?.find(r => (r.lessonId == lessonId && r.attended == 'Yes')));

// modals
const openSLPModal = async (isPreview = false) => {
  const ev = store.getters.getLastAttendedSession;
  return await openModal(SLPModal, { isPreview, ev, serviceId: ev?.serviceId, relatedProgramId: ev?.relatedProgramId, relatedClientId: user.value.clientId }, "", false)
};

// Other
const getSessionById = (sessionId: any) => (store.getters.getSessionById(sessionId));
const getServiceName = (service) => {
  const { lastAppliedSession, name } = service;
  return lastAppliedSession ? `${name} (${lastAppliedSession.date} ${lastAppliedSession.startTime})` : name;
};
const getServicesByIds = (ids) => (workServices.value || []).filter(s => ids.includes(s.id)); // TMP: for demo

const openScholarshipModal = () => {
  openServiceModal('lms-scholarship', getSessionById('e4c145b9'), true);
};

// Videos
const openVideoParentConsentModal = (videoId) => {
  return openModal(ParentConsentSignatureModal, { videoId, target: 'video' });
}

return (_ctx: any,_cache: any) => {
  const _component_home_action_item = _resolveComponent("home-action-item")!
  const _component_event_card = _resolveComponent("event-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[25] || (_cache[25] = _createElementVNode("img", {
      src: _imports_0,
      style: {"width":"100%","margin-bottom":"-3px"}
    }, null, -1)),
    _createVNode(_unref(IonToolbar), { style: {"--min-height":"27px"} }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), {
          lines: "full",
          button: "",
          detail: "",
          color: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openSLPModal(true)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { class: "ion-text-wrap ion-text-center" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "AchieveSLP preview", -1),
                _createElementVNode("small", null, "unlocked upon successful Work event enrollment", -1)
              ])),
              _: 1,
              __: [3]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonCard), { style: {"margin-top":"0"} }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardContent), { style: {"padding":"0"} }, {
          default: _withCtx(() => [
            true
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { style: {"margin":"0 0 12px 0","color":"#666","font-size":"14px"} }, "Exploring", -1)),
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                        return (_openBlock(), _createBlock(_unref(IonChip), {
                          class: "colored-chip",
                          key: tag.id,
                          onClick: ($event: any) => (selectTag(tag.id)),
                          style: _normalizeStyle([{"margin":"0"}, { '--background': selectedTagId.value === tag.id ? 'var(--ion-color-fdmtred)' : '#1A4924' }])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "style"]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Click', '1. Applied', '2. Nominated', '3. Confirmed interview', '4. Interview passed', 'Lead'], (status) => {
                        return _createVNode(_unref(IonChip), {
                          class: "colored-chip",
                          key: status,
                          onClick: ($event: any) => (selectApplicationStatus(status)),
                          style: _normalizeStyle([{"margin":"0"}, { '--background': selectedApplicationStatus.value === status ? 'var(--ion-color-fdmtred)' : '#004976' }])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { style: {"line-height":"1"} }, {
                              default: _withCtx(() => [
                                (status == 'Click')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[4] || (_cache[4] = [
                                      _createTextVNode("Please"),
                                      _createElementVNode("br", null, null, -1)
                                    ])))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(status) + " ", 1),
                                (status == 'Lead')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (by invitation)"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "style"])
                      }), 64))
                    ])
                  ]),
                  (filteredResults.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, "Results (" + _toDisplayString(filteredResults.value.length) + ")", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredResults.value, (result) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: result.id,
                            style: {"margin-bottom":"8px"}
                          }, [
                            (result.status === 'Click')
                              ? (_openBlock(), _createBlock(_unref(IonItem), {
                                  key: 0,
                                  button: "",
                                  onClick: ($event: any) => (toggleClickItem(result)),
                                  lines: "full",
                                  style: {"--padding-start":"0","--inner-padding-end":"0"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      icon: getClickStatus(result) ? _unref(checkmarkCircle) : _unref(alertCircle),
                                      color: getClickStatus(result) ? 'success' : 'danger',
                                      slot: "start"
                                    }, null, 8, ["icon", "color"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                          _createElementVNode("b", null, _toDisplayString(result.title), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_home_action_item, {
                                  key: 1,
                                  title: result.title,
                                  isLesson: true,
                                  onClick: ($event: any) => (openResultModal(result))
                                }, null, 8, ["title", "onClick"]))
                          ]))
                        }), 128))
                      ]))
                    : (selectedTagId.value || selectedApplicationStatus.value || selectedLead.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[6] || (_cache[6] = [
                          _createElementVNode("p", null, "No results found for the selected criteria.", -1)
                        ])))
                      : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_unref(IonCardContent), { style: {"padding":"0"} }, {
                    default: _withCtx(() => [
                      (user.value.relatedVideos?.length > 0)
                        ? (_openBlock(), _createBlock(ActionAccordionGroup, {
                            key: 0,
                            noPadding: false,
                            value: "parent-consent-videos",
                            headerColor: 'fdmtgrey'
                          }, {
                            header: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createElementVNode("b", null, "Video(s)", -1)
                                ])),
                                _: 1,
                                __: [7]
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.relatedVideos, (video) => {
                                return (_openBlock(), _createBlock(_component_home_action_item, {
                                  key: video.id,
                                  onClick: ($event: any) => (openVideoParentConsentModal(video.id)),
                                  isLesson: true,
                                  title: video.title
                                }, null, 8, ["onClick", "title"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "eligible-work-applicant",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "1. Eligible Work applicant")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWorkshopServicesByUserLevel('eligible-work-applicant'), (service) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: service.id
                              }, [
                                _createVNode(_component_home_action_item, {
                                  onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                  isLesson: true,
                                  title: getServiceName(service)
                                }, null, 8, ["onClick", "title"]),
                                (service.lastAppliedSession)
                                  ? (_openBlock(), _createBlock(_component_event_card, {
                                      key: 0,
                                      ev: service.lastAppliedSession,
                                      user: user.value,
                                      hideEventDetails: true,
                                      hideApplyButton: true,
                                      style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                    }, null, 8, ["ev", "user"]))
                                  : _createCommentVNode("", true)
                              ])), [
                                [_vShow, user.value.isAdmin ? !['s87bb705d', 's1b2ed9be'].includes(service.id) : true]
                              ])
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value, (ev) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: ev.id
                              }, [
                                _createVNode(_component_home_action_item, {
                                  onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, ev, true)),
                                  isLesson: true,
                                  title: `${ev.name} (${ev.date} ${ev.startTime})`
                                }, null, 8, ["onClick", "title"]),
                                (ev.userResponse)
                                  ? (_openBlock(), _createBlock(_component_event_card, {
                                      key: 0,
                                      ev: ev,
                                      user: user.value,
                                      hideEventDetails: true,
                                      hideApplyButton: true,
                                      style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                    }, null, 8, ["ev", "user"]))
                                  : _createCommentVNode("", true)
                              ])), [
                                [_vShow, user.value.isAdmin ? !['sd93a34f8'].includes(ev.serviceId) : true]
                              ])
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "shortlisted-work-applicant",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "2. Shortlisted Work applicant")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          (user.value.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByIds(['s87bb705d']), (service) => {
                                  return (_openBlock(), _createBlock(_component_home_action_item, {
                                    key: service.id,
                                    onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                    isLesson: true,
                                    title: getServiceName(service)
                                  }, null, 8, ["onClick", "title"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWorkshopServicesByUserLevel('shortlisted-work-applicant'), (service) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: service.id
                            }, [
                              _createVNode(_component_home_action_item, {
                                onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                isLesson: true,
                                title: getServiceName(service)
                              }, null, 8, ["onClick", "title"]),
                              (service.lastAppliedSession)
                                ? (_openBlock(), _createBlock(_component_event_card, {
                                    key: 0,
                                    ev: service.lastAppliedSession,
                                    user: user.value,
                                    hideEventDetails: true,
                                    hideApplyButton: true,
                                    style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                  }, null, 8, ["ev", "user"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "outstanding-work-applicant",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "3. (Outstanding) Work participant")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          (user.value.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByIds(['sd93a34f8']), (service) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: service.id
                                  }, [
                                    _createVNode(_component_home_action_item, {
                                      onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: getServiceName(service)
                                    }, null, 8, ["onClick", "title"]),
                                    (service.lastAppliedSession)
                                      ? (_openBlock(), _createBlock(_component_event_card, {
                                          key: 0,
                                          ev: service.lastAppliedSession,
                                          user: user.value,
                                          hideEventDetails: true,
                                          hideApplyButton: true,
                                          style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                        }, null, 8, ["ev", "user"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value, (ev) => {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: ev.id
                            }, [
                              _createVNode(_component_home_action_item, {
                                onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, ev, true)),
                                isLesson: true,
                                title: `${ev.name} (${ev.date} ${ev.startTime})`
                              }, null, 8, ["onClick", "title"])
                            ])), [
                              [_vShow, (ev.userResponse && ev.userResponse.isOutstandingStudent)]
                            ])
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "work-ambassador",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "4. Work Ambassador")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          (user.value.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByIds(['s1b2ed9be']), (service) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: service.id
                                  }, [
                                    _createVNode(_component_home_action_item, {
                                      onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: getServiceName(service)
                                    }, null, 8, ["onClick", "title"]),
                                    (service.lastAppliedSession)
                                      ? (_openBlock(), _createBlock(_component_event_card, {
                                          key: 0,
                                          ev: service.lastAppliedSession,
                                          user: user.value,
                                          hideEventDetails: true,
                                          hideApplyButton: true,
                                          style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                        }, null, 8, ["ev", "user"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (user.value.isAdmin || workVisitEvents.value.some(ev => ev.userResponse && ev.userResponse.isOutstandingStudent))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value.filter(ev => ev.userResponse && ev.userResponse.isOutstandingStudent), (ev) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: ev.id
                                  }, [
                                    _createVNode(_component_home_action_item, {
                                      onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, null, true, { isOutstandingParticipantView: true })),
                                      isLesson: true,
                                      title: "Example Work video & previous shooting photos"
                                    }, null, 8, ["onClick"])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "bluebird-seed-eligible-applicant",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "5. Bluebird Seed Eligible applicant")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createVNode(_component_home_action_item, {
                            isLesson: true,
                            title: "Bluebird Seed",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openServiceModal)('bluebird-seed')))
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "bluebird-seed-member",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "6. Bluebird Seed Member")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          (user.value.isAdmin && user.value.schoolId == 'htc')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_unref(IonItem), { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { style: {"padding-left":"32px"} }, {
                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createElementVNode("b", null, "Co-supervisors: Ms. Lilian Ho (HTC), Brandon Chan (FDMT)", -1)
                                      ])),
                                      _: 1,
                                      __: [14]
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(ActionAccordionGroup, {
                                  style: {"padding-left":"20px"},
                                  noPadding: true,
                                  headerColor: 'light',
                                  value: "tasks"
                                }, {
                                  header: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createElementVNode("p", null, [
                                      _createElementVNode("b", null, "Project logs")
                                    ], -1)
                                  ])),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_unref(IonItem), {
                                        button: "",
                                        lines: "full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), {
                                            class: "ion-text-wrap",
                                            style: {"padding-left":"32px"}
                                          }, {
                                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                                              _createElementVNode("b", null, "AchieveJUPAS UI Updates", -1),
                                              _createElementVNode("p", null, "Show version history of program choices", -1),
                                              _createElementVNode("p", null, "Expected completion: 2025-04-30", -1)
                                            ])),
                                            _: 1,
                                            __: [16]
                                          }),
                                          _createVNode(_unref(IonBadge), {
                                            color: "medium",
                                            slot: "end"
                                          }, {
                                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                                              _createTextVNode("Planned")
                                            ])),
                                            _: 1,
                                            __: [17]
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "bluebird-seed-scholarship-holder",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "7. Bluebird Seed Scholarship holder")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _cache[19] || (_cache[19] = _createElementVNode("div", null, null, -1))
                        ]),
                        _: 1,
                        __: [19]
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "bluebird-member",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "8. Bluebird Member")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _cache[21] || (_cache[21] = _createElementVNode("div", null, null, -1))
                        ]),
                        _: 1,
                        __: [21]
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "bluebird-scholarship-holder",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "9. Bluebird Scholarship holder")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _cache[23] || (_cache[23] = _createElementVNode("div", null, null, -1))
                        ]),
                        _: 1,
                        __: [23]
                      }),
                      _createVNode(ActionAccordionGroup, {
                        noPadding: false,
                        value: "Other",
                        headerColor: 'light'
                      }, {
                        header: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                            _createElementVNode("b", null, "Other")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createVNode(_component_home_action_item, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(openServiceModal)('lms-scholarship', getSessionById('e4c145b9'), true))),
                            isLesson: true,
                            title: "HK$300k scholarship",
                            isDisabled: !user.value.isAdmin && Number(user.value.yearDSE) >= _unref(getF5YearDSE)()
                          }, null, 8, ["isDisabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})